import {
    ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges,
    ViewChild
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SnackService} from '../../services/snack.service';
import {PaymentType} from '../../model/Entities/PaymentType';
import {ProductService} from '../../services/product.service';
import {Contract} from '../../model/Entities/Contract';
import {Customer} from '../../model/Entities/Customer';
import {Observable} from 'rxjs/Observable';
import {Filter} from '../../model/Helpers/Filter';
import {CustomerService} from '../../services/customer.service';
import {MatSort, MatTableDataSource} from '@angular/material';
import {ContractItem} from '../../model/Entities/ContractItem';
import {ContractService} from '../../services/contract.service';
import {FormControl, Validators} from '@angular/forms';
import {CustomerContactPersonService} from '../../services/customer-contact-person.service';
import {CustomerContactPerson} from '../../model/Entities/CustomerContactPerson';
import {numberValidator} from '../../validators/number.validator';
import {Product} from '../../model/Entities/Product';
import {ProductType} from '../../model/Entities/ProductType';
import {ProductContent} from '../../model/Entities/ProductContent';
import {ContractState} from '../../model/Entities/ContractState';
import {ContractItemService} from '../../services/contract-item.service';
import {VatRateService} from '../../services/vat-rate.service';
import {ContractItemTransferService} from '../../services/contract-item-transfer.service';
import {ContractItemTransfer} from '../../model/Entities/ContractItemTransfer';
import {DialogService} from '../../services/dialog.service';
import {ContractItemsTransferDialogComponent} from '../ContractItemsTransferDialogComponent/contract-items-transfer.dialog.component';
import {SingleContractItemTransferDialogComponent} from '../SingleContractItemTransferDialogComponent/single-contract-item-transfer.dialog.component';
import {ProductContractItem} from '../../model/Entities/ProductContractItem';

@Component({
    selector: 'contract-group-item-loss-list',
    templateUrl: './contract-group-item-loss-list.component.html',
    styleUrls: ['./contract-group-item-loss-list.component.scss']
})
export class ContractGroupItemLossListComponent implements OnInit {

    @Input() contractItem: ProductContractItem;
    @Input() items: any[];

    displayedColumns = ['itemName', 'dispatchedCount', 'returnedCount', 'lostCount'];
    itemsDataSource: MatTableDataSource<ProductContent> = new MatTableDataSource<ProductContent>([]);

    constructor(private contractItemService: ContractItemService,
                private contractItemTransferService: ContractItemTransferService,
                private productService: ProductService,
                private dialogService: DialogService,
                private snackService: SnackService) {

    }

    ngOnInit(): void {
        // console.log(this.contractItem);
        this.productService.get(this.contractItem.productId, {expand: 'content'}).subscribe((p: Product) => {
            p.content.forEach((c: ProductContent) => {
                c.lostCount = 0;
                this.items.push(c);
            });
            // console.log('ITEMS', this.items);
            this.reloadItemsDS();
            // console.log('DS', p);
        });
        // this.reloadItemsDS();
    }

    lostChanged(item: Product): void {
        // console.log('CHANGE', item, this.items);
    }

    public selectAll($event): void {
        $event.target.select();
    }

    // ngOnChanges(changes: SimpleChanges): void {
    //     if (changes.contract.previousValue !== changes.contract.currentValue
    //         && this.contract.id) {
    //         this.loadContractItems(this.contract.id);
    //     }
    //     this.reloadItemsDS();
    // }
    //
    // transferAll(): void {
    //     this.contractItems.forEach((i: ContractItem) => {
    //         if (i.isDeployment() || i.isDelivery() || i.isText()) {
    //             return;
    //         }
    //
    //         this.makeTransfer(i as ProductContractItem);
    //     });
    // }
    //
    // makeTransfer(ci: ProductContractItem, count: number | null = null): void {
    //     const transfer: ContractItemTransfer = new ContractItemTransfer();
    //     transfer.contractItemId = ci.id;
    //     if (count === null && this.direction === ContractItemTransfer.OUT) {
    //         transfer.count = ci.lentCount - ci.dispatched;
    //     } else if (count === null && this.direction === ContractItemTransfer.IN) {
    //         transfer.count = ci.dispatched - ci.returned;
    //     } else {
    //         transfer.count = count;
    //     }
    //
    //     if (transfer.count === 0) {
    //         return;
    //     }
    //
    //     transfer.direction = this.direction;
    //
    //     this.contractItemTransferService.save(transfer).subscribe((result: ContractItemTransfer) => {
    //         if (this.direction === ContractItemTransfer.IN) {
    //             ci.returned += result.count;
    //         } else {
    //             ci.dispatched += result.count;
    //         }
    //         this.reloadItemsDS();
    //     });
    // }
    //
    // openSingleTransferDialog(ci: ProductContractItem): void {
    //     this.dialogService.showDialog(SingleContractItemTransferDialogComponent, {
    //         'contractItem': ci,
    //         'direction': this.direction
    //     }, 400).afterClosed().subscribe((result: number) => {
    //         if (result) {
    //             this.makeTransfer(ci, result);
    //         }
    //     });
    // }
    //
    reloadItemsDS(): void {
        this.itemsDataSource = new MatTableDataSource<ProductContent>(this.items);
    }

    // private loadContractItems(contractId): void {
    //     this.contractItemService.getSimpleList([new Filter('contract_id', contractId)], {'expand': 'dispatched,returned'})
    //         .subscribe((items: ContractItem[]) => {
    //             this.contractItems = items;
    //             this.reloadItemsDS();
    //         });
    // }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/ContractGroupItemLossListComponent/contract-group-item-loss-list.component.ts